export const url = process.env?.REACT_APP_URL;
console.log("url", url);

const handleBaseUrl = () => {
  switch (url) {
    case "stage":
      return "https://2fagolc1t4.execute-api.us-west-2.amazonaws.com/setterDev/";
    case "dev":
      return "https://5svoah4qfb.execute-api.us-west-2.amazonaws.com/setterTest/";
    default:
      return "https://4rfbyp30tl.execute-api.us-west-2.amazonaws.com/setterProd/";
  }
};
const handleGoogleConversion = (url) => {
  switch (url) {
    case "stage":
    case "dev":
      return "https://www.google.com/maps/conversion/debug/collect";
    default:
      return "https://www.google.com/maps/conversion/collect";
  }
};

const handleXamplifierBaseUrl = () => {
  switch (url) {
    case "stage":
    case "dev":
      return "https://stage.api.config.layline.live/api/";
    default:
      return "https://api.config.layline.live/api/";
  }
};

const handlePermissionUrl = () => {
  switch (url) {
    case "stage":
    case "dev":
      return "https://stage.layline.live/api/user-permissions";
    default:
      return "https://insights.layline.live/api/user-permissions";
  }
};

const handleIndightURL = () => {
  switch (url) {
    case "stage":
    case "dev":
      return "https://stage.layline.live";
    default:
      return "https://insights.layline.live";
  }
};

const handleChangeUrl = () => {
  switch (url) {
    case "stage":
    case "dev":
      return {
        campaign: "https://stage.campaigns.layline.live/",
        listing: "https://stage.layline.live/listings",
        reputation:
          "https://stage.layline.live/dashboards/rep-summary/reputation",
        patientExperience:
          "https://stage.layline.live/dashboards/customer-experience/nps-overview",
        config: "https://stage.config.layline.live/",
        access: "https://dev.access.layline.live/login",
        layline: "https://stage.layline.live/welcome",
        forget: "https://stage.layline.live/password/reset",
        setter: "https://stage.setter.layline.live/",
      };
    default:
      return {
        campaign: "https://campaigns.layline.live/",
        listing: "https://listings.layline.live/listings",
        reputation:
          "https://insights.layline.live/dashboards/rep-summary/reputation",
        patientExperience:
          "https://insights.layline.live/dashboards/customer-experience/nps-overview",
        config: "https://config.layline.live/",
        access: "https://access.layline.live/",
        layline: "https://insights.layline.live/",
        forget: "https://insights.layline.live/password/reset",
        setter: "https://setter.layline.live/",
      };
  }
};


const handleS3Base = () => {
  switch (url) {
    case 'stage':
    case 'dev':
      return 'https://setter-dev.s3.us-west-2.amazonaws.com';
    default:
      return 'https://setter-prod.s3.us-west-2.amazonaws.com';
  }
};

export const BASE_URL = handleBaseUrl();
export const S3_BASE_URL = handleS3Base();
export const GOOGLE_CONVERSION = handleGoogleConversion();
export const XAMPLIFIER_BASE_URL = handleXamplifierBaseUrl();
export const DOMAIN_NAME = handleChangeUrl();
export const PERMISSION_URL = handlePermissionUrl();
export const INSIGHT_URL = handleIndightURL();
